module.exports = __webpack_public_path__ + "static/media/qbcompany.367c1079.png";